import React, { useState } from "react";

const EligibilityYTS = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Eligibility",
      content: `Prospective applicants must meet the following eligibility criteria:

1. Applicants must have completed a secondary school education or equivalent.

2. Basic understanding of international relations & trade concepts is preferred but not mandatory.

3. Proficiency in the English language (written & spoken) is required.

4. Undergraduate students & individuals with at least 2 years of work experience are eligible to apply.

5. Access to the internet is necessary for course participation.`,
    },
    {
      id: 2,
      title: "IT Requirements",
      content: `The course material will be delivered, & the learning objectives achieved through video-based teaching platforms & a specialised course Virtual Learning Environment (VLE). Therefore, you will require access to:
  
  - the internet via a computer, laptop, tablet, or other smart device
  - speakers or headphones to listen to any pre-recorded material or videos
  - a webcam & microphone for any interactive sessions that may be available`,
    },
    {
      id: 3,
      title: "Identity Check",
      content: `As part of your application, you will be required to provide a copy of your ID. At the beginning of the course, you will be required to attend a live zoom session, so that we can verify your identity.`,
    },
  ];

  return (
    <div className="md:scroll-mt-44 scroll-mt-16 my-10" id="eligibility">
      <div className="bg-sddarkgray py-3">
        <div className="max-w-6xl mx-auto px-3 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Eligibility & Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-2 px-3 bg-blue-50 hover:bg-blue-100 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">{section.title}</span>
                    <span>{activeSection === section.id ? "▲" : "▼"}</span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-sdbodywhite border-t border-gray-300">
                    <p className="text-gray-700 whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityYTS;
